import React from 'react'
import {connect} from 'react-redux'
import { closeModal } from "../actions"

const CloseBtn = ({dispatch, name, btnType="btn-primary"}) => {
    return (
        <button className={`btn ${btnType}`} onClick={() => dispatch(closeModal())}>
            {name}
        </button>
    )
}

const CloseModal = connect(null)(CloseBtn);

export default CloseModal
